import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Alert, Input, InputRef, Tabs } from 'antd';
import { PageTitle } from 'components/pageTitle';
import DoctorPageIcon from 'assets/images/doctor-page-icon.svg';
import { DoctorTabPane } from './components/tabs/DoctorTabPane';
import { HospitalTabPane } from './components/tabs/HospitalTabPane';
import { BookmarkTabPane } from './components/tabs/BookmarkTabPane';
import { BookmarkContextProvider } from '../../contexts/bookmark';
import React, { useRef, useEffect, useState, useContext } from 'react';
import { HomeContext } from 'contexts/home/context';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
`;

const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin: 0 0 0.5rem 0;
    padding: 0 1.5rem 0 1.5rem;
    background-color: white;
  }
`;

const StyledSearch = styled(Input.Search)`
  padding: 1rem 1.5rem 1rem 1.5rem;
  background-color: white;
  margin-top: 1.5rem;
`;

const StyledAlert = styled(Alert)`
  &&& {
    margin-top: 1.8rem;
  }
`;

interface tabList {
  label: string;
  key: string;
  children: JSX.Element;
}

const NetworkDoctorsPage = () => {
  const { t } = useTranslation();
  const inputEl = useRef<InputRef>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [tabList, SetTabList] = useState<tabList[]>([]);

  const { state } = useContext(HomeContext);
  const { userAccess } = state;

  useEffect(() => {
    if (userAccess) {
      if (!userAccess.hasHOSP) {
        SetTabList([
          {
            label: t('panelList.tabClinicDoctor'),
            key: '1',
            children: <DoctorTabPane inputEl={inputEl} wrapperRef={wrapperRef} />,
          },
          {
            label: t('panelList.tabBookmarks'),
            key: '3',
            children: <BookmarkTabPane inputEl={inputEl} wrapperRef={wrapperRef} />,
          },
        ]);
      } else {
        SetTabList([
          {
            label: t('panelList.tabClinicDoctor'),
            key: '1',
            children: <DoctorTabPane inputEl={inputEl} wrapperRef={wrapperRef} />,
          },
          {
            label: t('panelList.tabHospital'),
            key: '2',
            children: <HospitalTabPane inputEl={inputEl} wrapperRef={wrapperRef} />,
          },
          {
            label: t('panelList.tabBookmarks'),
            key: '3',
            children: <BookmarkTabPane inputEl={inputEl} wrapperRef={wrapperRef} />,
          },
        ]);
      }
    }
  }, [userAccess, t]);

  return (
    <BookmarkContextProvider>
      <Wrapper ref={wrapperRef}>
        <PageTitle title={t('panelList.bannerHeading')} icon={DoctorPageIcon} alt="doctorPageIcon" margin={'0px'} />
        <StyledAlert message={t('panelList.reminder')} type="warning" closable />
        <StyledSearch placeholder={t('panelList.searchDoctorOrClinic')} defaultValue={''} ref={inputEl} />
        <StyledTabs defaultActiveKey="1" destroyInactiveTabPane={true} items={tabList} />
      </Wrapper>
    </BookmarkContextProvider>
  );
};

export default NetworkDoctorsPage;
